module.exports = __webpack_public_path__ + "static/img/team_honor_order_32.9729ed9f.png";